var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-signup"},[_vm._t("title"),_vm._v(" "),_c('md-card-content',[_c('div',{staticClass:"md-layout"},[_vm._t("content-left"),_vm._v(" "),_vm._t("content-right")],2)]),_vm._v(" "),_c('md-card-actions',[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }